export default "__VITE_ASSET__zCeUTUnK__"